<template>
  <b-container>
    <div class="mt-5 pl-4 pr-4 pb-4 bg-white">
      <br>
      <h1><strong>What we offer</strong></h1>
      <br>
      <p style="text-align: justify">The <strong>CultureLabs platform</strong> aims to contribute to social innovation
        by facilitating in
        several ways the organisation of participatory projects. It is a single point of reference where different
        helpful material is collected and made openly available and searchable.
        <br>
        <br>
        Users who are interested to contribute to the platform are guided to document and disseminate not only the
        successful results of project, but also how these results were achieved, including inside tips and challenges
        encountered. We have started our effort by focusing on projects that aim at the social inclusion of migrants and
        refugees via cultural heritage but the platform can be used for structuring and spreading knowledge about any
        project in the cultural sector and beyond.
      </p>

      <p style="text-align: justify">To convey what the CL platform aims to do we borrow from the culinary
        terminology.</p>

      <p class="pl-2" style="text-align: justify;">
        <font-awesome-icon icon="concierge-bell" style="width: 20px"/>
        A <strong><i>Recipe</i></strong> is a structure that describes essential parts of a participatory project as a
        whole. A Recipe can be
        about a project that has been implemented, is ongoing, or is still at the planning phase. It aims to capture
        information that can be helpful for other people who wish to organise a similar initiative.
      </p>

      <p class="pl-2" style="text-align: justify;">
        <font-awesome-icon icon="utensils" style="width: 20px"/>
        An <strong><i>Ingredient</i></strong> is a digital asset that may come in different formats (document, image,
        link to a website, video,
        or some other external resource) and which can be useful for the organisation and implementation of a Recipe. It
        may include inspirational material from a past project, a methodology or tool that can be reused, (digitised)
        cultural heritage material used or created in the project for different purposes, a relevant policy, training
        material, etc.
      </p>

      <!--      <p style="text-align: justify">As a user of the CultureLabs platform, you can create your own ingredients and-->
      <!--        recipes and share them with a closed circle of users, by granting them different rights which enable different-->
      <!--        levels of collaboration (“read” and “edit” rights). You can also make your creations public, so that all-->
      <!--        visitors of the platform can discover, access, them and benefit from knowledge spreading. As a user of the-->
      <!--        CultureLabs platform, you can also take advantage of shared or public resources already created by others, and-->
      <!--        reuse existing ingredients in your own recipes, respecting the license under which they have been made-->
      <!--        available. You can also clone existing recipes and customise them to your own needs.-->
      <!--      </p>-->
      <br>
      <br>

      <h3 style="text-align: justify">
        <font-awesome-icon icon="hand-point-right"/>
        What you can do with the platform at a glance
      </h3>
      <h6 class="pl-4" style="text-align: justify"><span class="text-danger">*</span> Note: Some features have not been
        implemented yet.</h6>

      <div class="row text-left">
        <div class="pl-3 mt-2">
          <font-awesome-icon icon="search" style="width: 20px"/>
          <strong>Discover</strong></div>
        <div class="pl-3 mt-1">
          Discover inspirational and practical material (recipes and ingredients of recipes) by using the search
          functionality.<br>
          Find out, not only about successful outcomes, but, more importantly, about the process that was followed and
          the "inside" information, including the challenges encountered, practical tips, and helpful resources.
        </div>
      </div>
      <div class="row text-left mt-2">
        <div class="pl-3 mt-2">
          <font-awesome-icon icon="edit" style="width: 20px"/>
          <strong>Create</strong></div>
        <div class="pl-3 mt-1">
          Document past participatory projects. Structure in a collaborative way your ideas about new projects and
          deliver them as recipes.<br>
          Upload cultural heritage material, policies, links to digital tools, and other resources that can be useful
          for the organisation of such projects. Make them public so that others can benefit from that knowledge.
        </div>
      </div>
      <div class="row text-left mt-2">
        <div class="pl-3 mt-2">
          <font-awesome-icon icon="handshake" style="width: 20px"/>
          <strong>Collaborate</strong></div>
        <div class="pl-3 mt-1">
          Share your projects and resources with other users, ask for feedback, and collaborate with them on common
          projects.<br>
          Find organisations from the cultural, social and other fields and work together on a common project: it can be
          your own project shared with a closed group or a project that another creator has initiated and shared with
          you.
        </div>
      </div>
      <div class="text-left mt-3">
        <div class="pl-1 mt-2">
          <font-awesome-icon icon="comments" style="width: 20px"/>
          <strong>Communicate</strong></div>
        <div class="pl-1 mt-1">
          Communicate and exchange ideas.<br>
          Discuss your topics of interest in the <a href="http://recipes.culture-labs.eu/forum/"
                                                    target="_blank"><strong>forum</strong></a>.
        </div>
      </div>
      <div class="row text-left">
        <div class="pl-3 mt-3">
          <font-awesome-icon icon="copy" style="width: 20px"/>
          <strong>Reuse</strong></div>
        <div class="pl-3 mt-1">
          Copy and customise an existing project that you find useful and adapt it to your own needs.
          Reuse and combine parts of public projects uploaded by others, make changes, and complement them with your own
          material in order to construct a new participatory project that fits your specific situation.
        </div>
      </div>
      <br>
      <!--      ///////////////////////////////////////////////////////////////////////-->
<!--      <p class="pl-1" style="text-align: justify">-->
<!--        <font-awesome-icon icon="address-book"/>-->
<!--        Expand your network and find collaborators for your project.-->
<!--      </p>-->

      <br>

      <h3 style="text-align: justify">
        <font-awesome-icon icon="hand-point-right"/>
        Who the platform is addressed to:
      </h3>
      <ul class="pl-4">
        <li style="text-align: justify">Cultural Heritage professionals interested in making their organisations'
          collections more inclusive and engage with communities.
        </li>
        <li style="text-align: justify">People working in civil society organisations for the integration and
          empowerment of migrant communities and other disadvantaged communities.
        </li>
        <li style="text-align: justify">Public administrators implementing policies for societal cohesion.
        </li>
        <li style="text-align: justify">Researchers in social and cultural fields investigating the role of Cultural
          Heritage in society.
        </li>
        <li style="text-align: justify">Any community member and individual interested interested in participatory
          projects and wishing to raise awareness about grassroots heritage.
        </li>
      </ul>

      <p class="pl-1" style="text-align: justify">
        See the most suitable <router-link to="/workspace/our-users">scenarios and functionalities</router-link> we built for you!
      </p>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'WhatWeOffer.vue'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/WhatWeOffer.vue